import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { CenteredCardView } from '@vs-online-only-app/ui';

type Props = {
  startStepper: () => void;
};

const ProfileSetupLandingPage: FC<Props> = ({ startStepper }) => (
  <CenteredCardView
    body={
      <Stack gap={4}>
        <Typography variant="h4">Welcome to the Chat app</Typography>
        <Typography variant="body1">
          Let's get you up and running in just a few simple steps.
        </Typography>
        <Stack gap={2}>
          <Stack direction="row" gap={1}>
            <Typography fontWeight="bold">1. Set up your profile</Typography>
          </Stack>
          <Stack direction="row" gap={1}>
            <Typography fontWeight="bold">2. See how it works</Typography>
          </Stack>
        </Stack>
        <Button size="large" onClick={startStepper} variant="contained">
          Get started
        </Button>
      </Stack>
    }
  />
);

export default ProfileSetupLandingPage;
